import Cookies from 'js-cookie'

const language_cookie = 'language'
const userid_cookie = 'userid'
const username_cookie = 'username'
const clientname_cookie = 'clientname'
const factoryid_cookie = 'factoryid'
const lineid_cookie = 'lineid'
const JSESSIONID_cookie = 'JSESSIONID'

function getCookie(key) {
  return Cookies.get(key)
}

function setCookie(key, value) {
  return Cookies.set(key, value)
}

function removeCookie(key) {
  return Cookies.remove(key)
}

export default {
  JSESSIONID_cookie,
  language_cookie,
  userid_cookie,
  username_cookie,
  clientname_cookie,
  factoryid_cookie,
  lineid_cookie,
  getCookie,
  setCookie,
  removeCookie
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js